__turbopack_context__.v({
  "active": "NavbarSection-module__I6L8BG__active",
  "arrowIcon": "NavbarSection-module__I6L8BG__arrowIcon",
  "badgeBlue": "NavbarSection-module__I6L8BG__badgeBlue",
  "badgeGreen": "NavbarSection-module__I6L8BG__badgeGreen",
  "button": "NavbarSection-module__I6L8BG__button",
  "cartBadge": "NavbarSection-module__I6L8BG__cartBadge",
  "cartIcon": "NavbarSection-module__I6L8BG__cartIcon",
  "cartWrapper": "NavbarSection-module__I6L8BG__cartWrapper",
  "dropdownTitle": "NavbarSection-module__I6L8BG__dropdownTitle",
  "dropdownWrapper": "NavbarSection-module__I6L8BG__dropdownWrapper",
  "getStarted": "NavbarSection-module__I6L8BG__getStarted",
  "innerContainer": "NavbarSection-module__I6L8BG__innerContainer",
  "loadMoreBtn": "NavbarSection-module__I6L8BG__loadMoreBtn",
  "loadMoreWrapper": "NavbarSection-module__I6L8BG__loadMoreWrapper",
  "loginLink": "NavbarSection-module__I6L8BG__loginLink",
  "logoWrapper": "NavbarSection-module__I6L8BG__logoWrapper",
  "megaCard": "NavbarSection-module__I6L8BG__megaCard",
  "megaGrid": "NavbarSection-module__I6L8BG__megaGrid",
  "megaHeading": "NavbarSection-module__I6L8BG__megaHeading",
  "megaItem": "NavbarSection-module__I6L8BG__megaItem",
  "megaMenu": "NavbarSection-module__I6L8BG__megaMenu",
  "megaMenuSmall": "NavbarSection-module__I6L8BG__megaMenuSmall",
  "megaMenuSolutions": "NavbarSection-module__I6L8BG__megaMenuSolutions",
  "megaSolutionsCard": "NavbarSection-module__I6L8BG__megaSolutionsCard",
  "megaSolutionsGrid": "NavbarSection-module__I6L8BG__megaSolutionsGrid",
  "nav-link": "NavbarSection-module__I6L8BG__nav-link",
  "navLinks": "NavbarSection-module__I6L8BG__navLinks",
  "navSpacer": "NavbarSection-module__I6L8BG__navSpacer",
  "navText": "NavbarSection-module__I6L8BG__navText",
  "navbar": "NavbarSection-module__I6L8BG__navbar",
  "navbarWrapper": "NavbarSection-module__I6L8BG__navbarWrapper",
  "offcanvas": "NavbarSection-module__I6L8BG__offcanvas",
  "primaryHubCard": "NavbarSection-module__I6L8BG__primaryHubCard",
  "primaryHubRow": "NavbarSection-module__I6L8BG__primaryHubRow",
  "rightSection": "NavbarSection-module__I6L8BG__rightSection",
  "smallBox": "NavbarSection-module__I6L8BG__smallBox",
  "smallInner": "NavbarSection-module__I6L8BG__smallInner",
  "toggle": "NavbarSection-module__I6L8BG__toggle",
});
